import React from 'react';
import classNames from 'classnames';

import ButtonIcon from './ButtonIcon';
import SpinnerImage from 'src/viewLayer/assets/images/spinner.png';
import './index.scss';

const getClassNames = ({
  iconstart,
  inProgress: loading,
  micro,
  variant = 'primary'
}) => classNames('ButtonComponent', variant, iconstart, { micro, loading, iconified: iconstart });

const renderContent = ({
  inProgress,
  children,
  iconstart
}) => {
  if (inProgress) return <img className="spinner" src={SpinnerImage} />;

  const buttonText = <div className="btnText">{children}</div>;
  if (!iconstart) return buttonText;

  const buttonIcon = ButtonIcon(iconstart);
  return (
    <>
      { buttonIcon }
    </>
  );
};

export default ({
  disabled,
  onClick = () => { },
  ...props }
) => {
  return (
    <button
      id={ props.variant ? `uat-${props.variant}-button` : `uat-primary-button` }
      className={getClassNames(props)}
      disabled={disabled}
      onClick={onClick}
    >
      {renderContent(props)}
    </button>
  );
};
